import Form from '@components/Form'
import Select from '@components/Select'
import React, { Fragment } from 'react'
import { RenderDynamicFieldsProps } from './types'

const RenderDynamicFields: React.FC <RenderDynamicFieldsProps> = ({ fields, values, errors, setFieldValue }) => {

    return(

        <>
            {fields.map((item, index) => (
                <Fragment key = {index}>
                    {(() => {
                        if(['text', 'textArea'].includes(item.tipo)){
                            return(
                                <Form.Group
                                    label = {item.label}
                                    error = {errors[item.controllerName]}
                                    inputID = {item.controllerName}
                                    inputName = {item.controllerName}
                                    inputType = {item.tipo === 'textArea' ? 'textarea' : undefined}
                                />
                            )
                        }

                        if(['datetime'].includes(item.tipo)){
                            return(
                                <Form.Group
                                    label = {item.label}
                                    error = {errors[item.controllerName]}
                                    inputID = {item.controllerName}
                                    inputName = {item.controllerName}
                                    inputType = "date"
                                />
                            )
                        }

                        if(['selectded'].includes(item.tipo)){
                            return(
                                <Select
                                    type = "outline"
                                    label = {item.label}
                                    value = {values[item.controllerName]}
                                    fieldName = {item.controllerName}
                                    setFieldValue = {setFieldValue}
                                    items = {item.valores ?? []}
                                />
                            )
                        }
                    })()}
                </Fragment>
            ))}
        </>

    )

}

export default RenderDynamicFields